import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import FormEdit from '../../../../components/auth/balanco/listar/form_edit'
import Head from '../../../../components/head'
import Footer from '../../../../components/footer';


function EditarBalancoScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Balanco" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default EditarBalancoScreen;